// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"a07341f0","498":"eb2274e1","513":"acff8c4a","829":"693b0ef7","878":"68363c6c"}[chunkId] + ".chunk.js";
};